module.exports = __webpack_public_path__ + "media/images/flags/32/Albania-a65928f98ecc1314e6d1276a1e455e4e.png";